import { Colors, Constants, Fonts } from "../../../../config";
import { FestivalDao, LocationDao, VenueDao } from "../../../../DAO";
import React, { useEffect, useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import {
  capitalizeFirstLetter,
  getClass,
} from "../../../../helpers/formatHelpers";

import Link from "next/link";
import TagItem from "../../../../components/molecules/TagList/components/TagItem";
import moment from "moment";
import slugify from "slugify";
import { uniqBy } from "lodash";

const GuideProfile = (props) => {
  const { isMobileVersion, categoryType } = props;
  const {
    stateId,
    stateName,
    cityId,
    city,
    countryId,
    city_id,
    state_id,
    country_id,
    nationality,
    regionName,
    subRegionName,
    startDate,
    endDate,
    id,
    globalId,
  } = props.item;
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    onLoad();
  }, [JSON.stringify(props.item)]);

  const getMetaTitle = (item, type) => {
    const location =
      type === "world"
        ? "World"
        : type === "city"
        ? city
        : type === "state"
        ? stateName
        : type === "country"
        ? nationality
        : "";
    const result = `${
      (categoryType === Constants.categoryType.CATEGORY_ZOO ||
        categoryType === Constants.categoryType.CATEGORY_PARKFUL) &&
      item?.filterName !== "All"
        ? item?.filterName !== "All" &&
          item?.filterName !== "Aviary" &&
          item?.filterName !== "Animal sanctuary" &&
          item?.filterName !== "Basic" &&
          item?.filterName !== "Premium" &&
          item?.filterName !== "Luxury" &&
          item?.filterName !== "Best"
          ? item?.filterName + "s "
          : item?.filterName
              ?.replace("Aviary", "Aviaries")
              ?.replace("Animal sanctuary", "Animal sanctuaries") + " "
        : item?.filterName !== "Pool" &&
          item?.filterName !== "Bar" &&
          item?.filterName !== "Restaurant"
        ? item?.filterName
            ?.replace("All", "")
            ?.replace("Day Spa", "Day")
            ?.replace("Destination Spa", "Destination")
            ?.replace("Thermal Spa", "Thermal")
            ?.replace("Hotel Spa", "Hotel")
            ?.replace("Club Spa", "Club")
            ?.replace("Medical Spa", "Medical")
            ?.toLowerCase() + " "
        : ""
    }${
      process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
        ? "clubs"
        : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
        ? item?.filterName === "Pool" ||
          item?.filterName === "Bar" ||
          item?.filterName === "Restaurant"
          ? "rooftop"
          : "rooftops"
        : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
        ? "cocktail bars"
        : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
        ? "spas"
        : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
        ? "beach clubs"
        : process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld"
        ? "prefab homes manufacturers"
        : process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia"
        ? item?.filterName === "All"
          ? "zoos & animal parks"
          : ""
        : process.env.NEXT_PUBLIC_APP_NAME == "Parkful"
        ? item?.filterName === "All" || item?.filterName === "Best"
          ? "amusement parks"
          : ""
        : process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino"
        ? "casinos"
        : process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia"
        ? "castles"
        : process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club"
        ? "luxury resorts"
        : process.env.NEXT_PUBLIC_APP_NAME == "AparthotelClub"
        ? "aparthotels"
        : process.env.NEXT_PUBLIC_APP_NAME == "Festyful"
        ? "festivals"
        : "clubs"
    }${
      item?.filterName === "Pool" ||
      item?.filterName === "Bar" ||
      item?.filterName === "Restaurant"
        ? " " + item?.filterName?.replace("All", "")?.toLowerCase() + "s "
        : " "
    }${location || "World"}`;

    return capitalizeFirstLetter(result?.trim());
  };

  const getMetaLink = (item, type) => {
    const continent =
      type === "world"
        ? "World"
        : regionName === "Americas"
        ? subRegionName !== "South America" &&
          subRegionName !== "Northern America"
          ? "South America"
          : subRegionName?.replace("Northern", "North")?.toLowerCase()
        : regionName?.toLowerCase();
    const prefixURL =
      type === "city"
        ? `/guides/${
            process.env.NEXT_PUBLIC_APP_NAME == "Festyful"
              ? `${moment(startDate).format("YYYY")}/`
              : ""
          }${slugify(continent?.toLowerCase())}/${slugify(
            nationality?.toLowerCase()
          )}/${slugify(city?.toLowerCase())}${
            process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia" ||
            process.env.NEXT_PUBLIC_APP_NAME == "Parkful" ||
            process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino" ||
            process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia" ||
            process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club" ||
            process.env.NEXT_PUBLIC_APP_NAME == "AparthotelClub"
              ? "-city"
              : ""
          }`
        : type === "state"
        ? `/guides/${
            process.env.NEXT_PUBLIC_APP_NAME == "Festyful"
              ? `${moment(startDate).format("YYYY")}/`
              : ""
          }${
            process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld"
              ? ""
              : `${slugify(continent?.toLowerCase())}/`
          }${slugify(nationality?.toLowerCase())}/${slugify(
            stateName?.toLowerCase()
          )}${
            process.env.NEXT_PUBLIC_APP_NAME == "Festyful" ||
            process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld" ||
            process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia" ||
            process.env.NEXT_PUBLIC_APP_NAME == "Parkful" ||
            process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino" ||
            process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia" ||
            process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club" ||
            process.env.NEXT_PUBLIC_APP_NAME == "AparthotelClub"
              ? "-state"
              : ""
          }`
        : type === "country"
        ? `/guides/${
            process.env.NEXT_PUBLIC_APP_NAME == "Festyful"
              ? `${moment(startDate).format("YYYY")}/`
              : ""
          }${
            process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld"
              ? ""
              : `${slugify(continent?.toLowerCase())}/`
          }${slugify(nationality?.toLowerCase())}`
        : type === "world"
        ? `/guides/world/`
        : "";
    const filterName = `${
      item?.filterName === "All"
        ? process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
          ? "clubs"
          : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
          ? "rooftops"
          : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
          ? "cocktail-bars"
          : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
          ? "spas"
          : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
          ? "beach-clubs"
          : process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld"
          ? "prefab-homes-manufacturers"
          : process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia"
          ? "all"
          : process.env.NEXT_PUBLIC_APP_NAME == "Parkful"
          ? "all"
          : process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino"
          ? "all"
          : process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia"
          ? "all"
          : process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club"
          ? "all"
          : process.env.NEXT_PUBLIC_APP_NAME == "AparthotelClub"
          ? "all"
          : process.env.NEXT_PUBLIC_APP_NAME == "Festyful"
          ? "festivals"
          : "clubs"
        : (process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia" ||
          process.env.NEXT_PUBLIC_APP_NAME == "Parkful" ||
          process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino" ||
          process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia"
            ? item?.filterName !== "All" &&
              item?.filterName !== "Aviary" &&
              item?.filterName !== "Animal sanctuary" &&
              item?.filterName !== "Basic" &&
              item?.filterName !== "Premium" &&
              item?.filterName !== "Luxury" &&
              item?.filterName !== "Best"
              ? slugify(item?.filterName?.toLowerCase()) + "s"
              : slugify(
                  item?.filterName
                    ?.replace("Aviary", "Aviaries")
                    ?.replace("Animal sanctuary", "Animal sanctuaries")
                    ?.toLowerCase()
                )
            : item?.filterName !== "Pool" &&
              item?.filterName !== "Bar" &&
              item?.filterName !== "Restaurant"
            ? slugify(item?.filterName?.replace(" Spa", "")?.toLowerCase()) +
              "-"
            : "") +
          `${
            process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
              ? "clubs"
              : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
              ? item?.filterName === "Pool" ||
                item?.filterName === "Bar" ||
                item?.filterName === "Restaurant"
                ? "rooftop"
                : "rooftops"
              : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
              ? "cocktail-bars"
              : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
              ? "spas"
              : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
              ? "beach-clubs"
              : process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld"
              ? "prefab-homes-manufacturers"
              : process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia"
              ? ""
              : process.env.NEXT_PUBLIC_APP_NAME == "Parkful"
              ? ""
              : process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino"
              ? ""
              : process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia"
              ? ""
              : process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club"
              ? ""
              : process.env.NEXT_PUBLIC_APP_NAME == "AparthotelClub"
              ? ""
              : process.env.NEXT_PUBLIC_APP_NAME == "Festyful"
              ? "festivals"
              : "clubs"
          }${
            item &&
            (item?.filterName === "Pool" ||
              item?.filterName === "Bar" ||
              item?.filterName === "Restaurant")
              ? "-" + slugify(item?.filterName?.toLowerCase() + "s")
              : ""
          }`
    }`;
    return `${prefixURL}/${
      (process.env.NEXT_PUBLIC_APP_NAME == "Festyful" ||
        process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld") &&
      (type === "state" || type === "city")
        ? ""
        : filterName
    }`;
  };

  const onLoad = () => {
    if (isLoading) return;
    setIsLoading(true);

    let results = [];

    if (
      process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld" ||
      process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia" ||
      process.env.NEXT_PUBLIC_APP_NAME == "Parkful" ||
      process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino" ||
      process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club"
    ) {
      LocationDao.findProgmatic({
        categoryType,
        progFilterType: "filter",
      }).then(async (resultWorld) => {
        results = results.concat(
          await Promise.all(
            uniqBy(resultWorld, "filterId")
              .map(async (item) => {
                const { listDataResult, countListDataResult } =
                  await new Promise((resolve, reject) => {
                    VenueDao.find({
                      categoryType,
                      pageIndex: 0,
                      pageSize: 1,
                      sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                      progFilterId: item.filterId,
                      globalId,
                    })
                      .then((result) =>
                        resolve({
                          listDataResult: result.data,
                          countListDataResult: result.totalCount,
                        })
                      )
                      .catch((err) => reject(err));
                  });

                if (listDataResult.find((i) => i.id === id)) {
                  return {
                    ...item,
                    metaTitle: getMetaTitle(item, "world"),
                    metaLink: getMetaLink(item, "world"),
                    type: "world",
                  };
                }

                return null;
              })
              .filter((i) => i)
          )
        );

        onLoadSecond(results);
      });
    } else {
      onLoadSecond(results);
    }
  };

  const onLoadSecond = (results) => {
    LocationDao.findProgmatic({
      categoryType,
      progFilterType: "filter",
      countryId:
        process.env.NEXT_PUBLIC_APP_NAME === "Festyful"
          ? country_id
          : countryId,
      year:
        process.env.NEXT_PUBLIC_APP_NAME === "Festyful"
          ? moment(startDate).format("YYYY")
          : null,
    }).then(async (resultCountry) => {
      if (
        nationality &&
        resultCountry.find((i) => i.countryId == countryId) &&
        (process.env.NEXT_PUBLIC_APP_NAME == "SpaClub" ||
          process.env.NEXT_PUBLIC_APP_NAME == "Beachful")
      ) {
        results = results.concat(
          await Promise.all(
            uniqBy(resultCountry, "filterId")
              .map(async (item) => {
                const { listDataResult, countListDataResult } =
                  await new Promise((resolve, reject) => {
                    VenueDao.find({
                      categoryType,
                      pageIndex: 0,
                      pageSize: 1,
                      venueStatus: [
                        Constants.venueStatus.FE_STAT_OPEN,
                        Constants.venueStatus.FE_STAT_CLOSE,
                        Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED,
                      ],
                      sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                      progFilterId: item.filterId,
                      countryId: [countryId],
                      globalId,
                    })
                      .then((result) =>
                        resolve({
                          listDataResult: result.data,
                          countListDataResult: result.totalCount,
                        })
                      )
                      .catch((err) => reject(err));
                  });

                if (listDataResult.find((i) => i.id === id)) {
                  return {
                    ...item,
                    metaTitle: getMetaTitle(item, "country"),
                    metaLink: getMetaLink(item, "country"),
                    type: "country",
                  };
                }

                return null;
              })
              .filter((i) => i)
          )
        );
      } else if (
        nationality &&
        resultCountry.find((i) => i.countryId == country_id) &&
        process.env.NEXT_PUBLIC_APP_NAME == "Festyful"
      ) {
        results = results.concat(
          await Promise.all(
            uniqBy(resultCountry, "filterId")
              .map(async (item) => {
                const { listDataResult, countListDataResult } =
                  await new Promise((resolve, reject) => {
                    FestivalDao.findWeb({
                      categoryType,
                      pageIndex: 0,
                      pageSize: 1,
                      sortType: Constants.sortByAction.SORT_BY_RECENT,
                      startDateFrom: moment(startDate)
                        .startOf("year")
                        .format("YYYY-MM-DD"),
                      startDateTo: moment(startDate)
                        .endOf("year")
                        .format("YYYY-MM-DD"),
                      progFilterId: item.filterId,
                      countryId: [country_id],
                      globalId,
                    })
                      .then((result) =>
                        resolve({
                          listDataResult: result.data,
                          countListDataResult: result.totalCount,
                        })
                      )
                      .catch((err) => reject(err));
                  });

                if (listDataResult.find((i) => i.id === id)) {
                  return {
                    ...item,
                    metaTitle: getMetaTitle(item, "country"),
                    metaLink: getMetaLink(item, "country"),
                    type: "country",
                  };
                }

                return null;
              })
              .filter((i) => i)
          )
        );
      } else if (
        nationality &&
        resultCountry.find((i) => i.countryId == countryId) &&
        (process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld" ||
          process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia" ||
          process.env.NEXT_PUBLIC_APP_NAME == "Parkful" ||
          process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino" ||
          process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia" ||
          process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club" ||
          process.env.NEXT_PUBLIC_APP_NAME == "AparthotelClub")
      ) {
        results = results.concat(
          await Promise.all(
            uniqBy(resultCountry, "filterId")
              .map(async (item) => {
                const { listDataResult, countListDataResult } =
                  await new Promise((resolve, reject) => {
                    VenueDao.find({
                      categoryType,
                      pageIndex: 0,
                      pageSize: 1,
                      sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                      progFilterId: item.filterId,
                      countryId: [countryId],
                      globalId,
                    })
                      .then((result) =>
                        resolve({
                          listDataResult: result.data,
                          countListDataResult: result.totalCount,
                        })
                      )
                      .catch((err) => reject(err));
                  });

                if (listDataResult.find((i) => i.id === id)) {
                  return {
                    ...item,
                    metaTitle: getMetaTitle(item, "country"),
                    metaLink: getMetaLink(item, "country"),
                    type: "country",
                  };
                }

                return null;
              })
              .filter((i) => i)
          )
        );
      }

      LocationDao.findProgmatic({
        categoryType,
        progFilterType:
          process.env.NEXT_PUBLIC_APP_NAME === "Festyful" ? "state" : "filter",
        countryId:
          process.env.NEXT_PUBLIC_APP_NAME === "Festyful"
            ? country_id
            : countryId,
        stateId:
          process.env.NEXT_PUBLIC_APP_NAME === "Festyful" ? null : stateId,
        year:
          process.env.NEXT_PUBLIC_APP_NAME === "Festyful"
            ? moment(startDate).format("YYYY")
            : null,
      }).then(async (resultState) => {
        if (
          stateName &&
          resultState.find((i) => i.stateId == stateId) &&
          (process.env.NEXT_PUBLIC_APP_NAME == "SpaClub" ||
            process.env.NEXT_PUBLIC_APP_NAME == "Beachful")
        ) {
          results = results.concat(
            await Promise.all(
              uniqBy(resultState, "filterId").map(async (item) => {
                const { listDataResult, countListDataResult } =
                  await new Promise((resolve, reject) => {
                    VenueDao.find({
                      categoryType,
                      pageIndex: 0,
                      pageSize: 1,
                      venueStatus: [
                        Constants.venueStatus.FE_STAT_OPEN,
                        Constants.venueStatus.FE_STAT_CLOSE,
                        Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED,
                      ],
                      sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                      progFilterId: item.filterId,
                      countryId: [countryId],
                      stateId,
                      globalId,
                    })
                      .then((result) =>
                        resolve({
                          listDataResult: result.data,
                          countListDataResult: result.totalCount,
                        })
                      )
                      .catch((err) => reject(err));
                  });

                if (listDataResult.find((i) => i.id === id)) {
                  return {
                    ...item,
                    metaTitle: getMetaTitle(item, "state"),
                    metaLink: getMetaLink(item, "state"),
                    type: "state",
                  };
                }

                return null;
              })
            )
          );
        } else if (
          stateName &&
          resultState.find((i) => i.stateId == state_id) &&
          process.env.NEXT_PUBLIC_APP_NAME == "Festyful"
        ) {
          results = results.concat(
            await Promise.all(
              uniqBy(resultState, "filterId").map(async (item) => {
                const { listDataResult, countListDataResult } =
                  await new Promise((resolve, reject) => {
                    FestivalDao.findWeb({
                      categoryType,
                      pageIndex: 0,
                      pageSize: 1,
                      sortType: Constants.sortByAction.SORT_BY_RECENT,
                      startDateFrom: moment(startDate)
                        .startOf("year")
                        .format("YYYY-MM-DD"),
                      startDateTo: moment(startDate)
                        .endOf("year")
                        .format("YYYY-MM-DD"),
                      progFilterId: item.filterId,
                      stateId: state_id,
                      countryId: [country_id],
                      globalId,
                    })
                      .then((result) =>
                        resolve({
                          listDataResult: result.data,
                          countListDataResult: result.totalCount,
                        })
                      )
                      .catch((err) => reject(err));
                  });

                if (listDataResult.find((i) => i.id === id)) {
                  return {
                    ...item,
                    metaTitle: getMetaTitle(item, "state"),
                    metaLink: getMetaLink(item, "state"),
                    type: "state",
                  };
                }

                return null;
              })
            )
          );
        } else if (
          stateName &&
          resultState.find((i) => i.stateId == stateId) &&
          (process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld" ||
            process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia" ||
            process.env.NEXT_PUBLIC_APP_NAME == "Parkful" ||
            process.env.NEXT_PUBLIC_APP_NAME == "WorldCasino" ||
            process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia" ||
            process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club" ||
            process.env.NEXT_PUBLIC_APP_NAME == "AparthotelClub")
        ) {
          results = results.concat(
            await Promise.all(
              uniqBy(resultState, "filterId").map(async (item) => {
                const { listDataResult, countListDataResult } =
                  await new Promise((resolve, reject) => {
                    VenueDao.find({
                      categoryType,
                      pageIndex: 0,
                      pageSize: 1,
                      sortType: Constants.sortByAction.SORT_BY_RECOMMENDED,
                      progFilterId: item.filterId,
                      countryId: [countryId],
                      stateId,
                      globalId,
                    })
                      .then((result) =>
                        resolve({
                          listDataResult: result.data,
                          countListDataResult: result.totalCount,
                        })
                      )
                      .catch((err) => reject(err));
                  });

                if (listDataResult.find((i) => i.id === id)) {
                  return {
                    ...item,
                    metaTitle: getMetaTitle(item, "state"),
                    metaLink: getMetaLink(item, "state"),
                    type: "state",
                  };
                }

                return null;
              })
            )
          );
        }

        LocationDao.findProgmatic({
          categoryType,
          progFilterType:
            process.env.NEXT_PUBLIC_APP_NAME === "Festyful" ? "city" : "filter",
          countryId:
            process.env.NEXT_PUBLIC_APP_NAME === "Festyful"
              ? country_id
              : countryId,
          stateId:
            process.env.NEXT_PUBLIC_APP_NAME === "Festyful" ? null : stateId,
          cityId:
            process.env.NEXT_PUBLIC_APP_NAME === "Festyful" ? null : cityId,
          year:
            process.env.NEXT_PUBLIC_APP_NAME === "Festyful"
              ? moment(startDate).format("YYYY")
              : null,
        }).then(async (resultCity) => {
          if (
            city &&
            process.env.NEXT_PUBLIC_APP_NAME !== "PrefabWorld" &&
            resultCity.find(
              (i) =>
                i.cityId ==
                (process.env.NEXT_PUBLIC_APP_NAME === "Festyful"
                  ? city_id
                  : cityId)
            )
          ) {
            results = results.concat(
              await Promise.all(
                uniqBy(resultCity, "filterId")
                  .map(async (item) => {
                    if (process.env.NEXT_PUBLIC_APP_NAME === "Festyful") {
                      const { listDataResult, countListDataResult } =
                        await new Promise((resolve, reject) => {
                          FestivalDao.findWeb({
                            categoryType,
                            pageIndex: 0,
                            pageSize: 1,
                            sortType: Constants.sortByAction.SORT_BY_RECENT,
                            startDateFrom: moment(startDate)
                              .startOf("year")
                              .format("YYYY-MM-DD"),
                            startDateTo: moment(startDate)
                              .endOf("year")
                              .format("YYYY-MM-DD"),
                            progFilterId: item.filterId,
                            cityId: city_id,
                            stateId: state_id,
                            countryId: [country_id],
                            globalId,
                          })
                            .then((result) =>
                              resolve({
                                listDataResult: result.data,
                                countListDataResult: result.totalCount,
                              })
                            )
                            .catch((err) => reject(err));
                        });

                      if (listDataResult.find((i) => i.id === id)) {
                        return {
                          ...item,
                          metaTitle: getMetaTitle(item, "city"),
                          metaLink: getMetaLink(item, "city"),
                          type: "city",
                        };
                      }
                    } else {
                      const { listDataResult, countListDataResult } =
                        await new Promise((resolve, reject) => {
                          VenueDao.find({
                            categoryType,
                            pageIndex: 0,
                            pageSize: 1,
                            venueStatus: [
                              Constants.venueStatus.FE_STAT_OPEN,
                              Constants.venueStatus.FE_STAT_CLOSE,
                              Constants.venueStatus.FE_STAT_TEMPORARILY_CLOSED,
                            ],
                            sortType:
                              Constants.sortByAction.SORT_BY_RECOMMENDED,
                            progFilterId: item.filterId,
                            countryId: [countryId],
                            stateId,
                            cityId,
                            globalId,
                          })
                            .then((result) =>
                              resolve({
                                listDataResult: result.data,
                                countListDataResult: result.totalCount,
                              })
                            )
                            .catch((err) => reject(err));
                        });

                      if (listDataResult.find((i) => i.id === id)) {
                        return {
                          ...item,
                          metaTitle: getMetaTitle(item, "city"),
                          metaLink: getMetaLink(item, "city"),
                          type: "city",
                        };
                      }
                    }

                    return null;
                  })
                  .filter((i) => i)
              )
            );
          }
          setItems(results.filter((i) => i && i.metaLink));
        });
      });
    });
  };

  return (
    <View style={[styles.container, props.style]}>
      <div className={isMobileVersion ? "px-4" : ""}>
        <View
          style={[
            styles.itemContainer,
            isMobileVersion ? { height: 32, width: 120, marginTop: 30 } : {},
          ]}>
          <Text
            style={[
              styles.title,
              isMobileVersion ? { fontSize: 12, lineHeight: 12 } : {},
            ]}>
            <h2>Guides</h2>
          </Text>
          <Text
            style={[
              styles.description,
              isMobileVersion ? { fontSize: 12, lineHeight: 12 } : {},
            ]}>
            {
              items
                .filter((item) =>
                  process.env.NEXT_PUBLIC_APP_NAME == "Festyful" &&
                  item.type != "country"
                    ? item.metaTitle.trim()[0] == "F"
                      ? item
                      : null
                    : item
                )
                .filter((item) =>
                  process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld" &&
                  item.type != "country" &&
                  item.type != "world"
                    ? item.metaTitle.trim()[0] == "P"
                      ? item
                      : null
                    : item
                ).length
            }
          </Text>
        </View>
        <View
          style={{
            flexWrap: "wrap",
            flexDirection: "row",
            paddingRight: 20,
            marginTop: 30,
            paddingHorizontal: 16,
          }}>
          {items
            .filter((item) =>
              process.env.NEXT_PUBLIC_APP_NAME == "Festyful" &&
              item.type != "country"
                ? item.metaTitle.trim()[0] == "F"
                  ? item
                  : null
                : item
            )
            .filter((item) =>
              process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld" &&
              item.type != "country" &&
              item.type != "world"
                ? item.metaTitle.trim()[0] == "P"
                  ? item
                  : null
                : item
            )
            .filter((item) => item)
            .map((item) => (
              <Link href={item.metaLink}>
                <a>
                  <TagItem
                    item={{ title: item.metaTitle?.replace("R&b", "R&B") }}
                    onPressItem={null}
                    isMobileVersion={isMobileVersion}
                  />
                </a>
              </Link>
            ))}
        </View>
      </div>
    </View>
  );
};

const styles = StyleSheet.create({
  itemContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 25,
    marginLeft: 16,
    marginBottom: 30,
    height: 50,
    width: 200,
    backgroundColor: getClass("bg-gray1"),
  },
  container: {
    alignSelf: "stretch",
  },
  title: {
    color: "white",
    fontSize: 18,
    lineHeight: 30,
    fontWeight: "700",
    fontFamily: Fonts.primaryBold,
  },
  description: {
    color: getClass("text-gray2"),
    fontSize: 18,
    lineHeight: 30,
    fontWeight: "700",
    marginLeft: 8,
    fontFamily: Fonts.primaryBold,
  },
  loadMoreButtonContainer: {
    width: 180,
    height: 40,
    borderWidth: 1,
    borderColor: Colors.spliterLine,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 18,
  },
  mobileLoadMoreButtonContainer: {
    width: 120,
    height: 32,
    borderWidth: 1,
    borderColor: Colors.spliterLine,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 18,
  },
  buttonText: {
    color: Colors.white,
    fontFamily: Fonts.primaryBold,
    fontSize: 16,
    textAlign: "center",
  },
});

export default GuideProfile;
